import React, { Component } from "react";
import PropTypes from "prop-types";

import EditableInput from "../EditableInput";
import appConfig from "../../../config/app";

class ContactRow extends Component {
  handleInputChange = (field, value) => {
    this.props.onChange(field, value, this.props.rowKey);
  };

  handleCheckboxChange = e => {
    this.props.onChange(e.target.name, e.target.checked ? 1 : 0, this.props.rowKey);
  };

  isActiveIntegration = appConfig.isActivePoleplanIntegration.toString() !== '0';

  render() {
    const { isEditMode, rowData, hideIsVisibleField } = this.props;

    return (
      <div className="col-xs-12">
        <div className="col-xs-3">
          <div className="col-xs-4 custom-form__label">Телефон:</div>
          <div className="col-xs-7">
            {/* Запросы на onChange  */}
            <EditableInput
              type="text"
              value={rowData.phone}
              onChange={this.handleInputChange}
              name="phone"
              editMode={!isEditMode || !rowData.phone }
            />
          </div>
        </div>
        <div className="col-xs-4 max">
          <div className="col-xs-4 custom-form__label">Владелец контакта:</div>
          <div className="col-xs-7">
            <EditableInput
              type="text"
              value={rowData.name}
              onChange={this.handleInputChange}
              name="name"
              editMode={!isEditMode || !rowData.name.length}
            />
          </div>
        </div>
        <div className="col-xs-3">
          <div className="col-xs-4 custom-form__label">Email:</div>
          <div className="col-xs-8">
            <EditableInput
              type="text"
              value={rowData.email}
              onChange={this.handleInputChange}
              name="email"
              editMode={!isEditMode || !rowData.email}
            />
          </div>
        </div>
        <div className="col-xs-2" hidden={hideIsVisibleField || !this.isActiveIntegration}>
          <div className="col-xs-6 mr-left-20 custom-form__label">Импорт в Poleplan:</div>
          <div className="col-xs-2">
            <input
                type="checkbox"
                name="isVisible"
                checked={rowData.isVisible}
                onChange={this.handleCheckboxChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

ContactRow.propTypes = {
  onChange: PropTypes.func.isRequired,
  hideIsVisibleField: PropTypes.bool,
  rowData: PropTypes.object,
  rowKey: PropTypes.number.isRequired,
  isEditMode: PropTypes.bool
};

export default ContactRow;



// WEBPACK FOOTER //
// ./components/ClientForm/Contacts/ContactRow.js